module.exports = __webpack_public_path__ + "static/ditoLogo.ae4515ec.png";